import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function initModifications() {
    let modificationsSelect = $('.js-product-variants');

    modificationsSelect.on('change', function () {
        window.location.href = $(this).val();
    });

    let selectedIndex = 0;
    let slides = $('.modifications-gallery .swiper-slide');
    const activeClass ='active';
    let pathAfterSlash = location.href.split('/').pop().split('?')[0];

    if(!pathAfterSlash) return;

    slides.each((idx, el) => {
        const slide = $(el);
        let dataURL = slide.data('url');

        if(dataURL.endsWith('/')) {
            dataURL = dataURL.substring(0, dataURL.length-1);
        }
        dataURL = dataURL.split('/').pop();

        if(pathAfterSlash == dataURL) {
            slide.addClass(activeClass);
            selectedIndex = idx;
        }
    });


    let mySwiper = new Swiper('.modifications-gallery', {
        speed: 200,
        slidesPerView: 'auto',
        initialSlide: selectedIndex,
        modules: [Navigation],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });

    //mySwiper.slideTo(selectedIndex, 0, false);
}
